<template>
  <div class="dashboard">
    <div class="table">
      <vue-element-loading :active="loading" color="#00cca2" spinner="spinner"/>
      <a-table size="small" :pagination="false" :bordered='false' rowKey="id"
        :columns="columns" :dataSource="list">
          <template slot="index" slot-scope="text, record , index">
            <span v-if="index+1 == list.length">合计</span>
            <span v-else>{{(index+1) + pageParams.perPage * (pageParams.currentPage - 1)}}</span>
          </template>
      </a-table>
    </div>
    <div class="page">
      <a-pagination
        :pageSizeOptions="pageSizeOptions"
        :total="pageParams.totalCount"
        showSizeChanger
        :pageSize="pageParams.perPage"
        v-model="current"
        @change="changePage"
        @showSizeChange="onShowSizeChange"
          :showTotal="total => `共 ${pageParams.totalCount.toLocaleString()}条 `"
      >
          <template slot='buildOptionText' slot-scope='props'>
            <span v-if="props.value!=='100'">{{props.value}}条/页</span>
            <span v-if="props.value==='100'">100条/页</span>
          </template>
        </a-pagination>
    </div>
  </div>
</template>

<script>
const columns = [
  { title: '#', width:'55px', scopedSlots: { customRender: 'index' }, key: 'index'},
  { title: '支付内容', dataIndex: 'title', key: 'name' , ellipsis: true},
  { title: '交易订单号', dataIndex: 'out_trade_no', key: 'age'},
  { title: '交易类型', dataIndex: 'type', key: '1' },
  { title: '支付金额', dataIndex: 'total_fee', key: '2' ,align:"right"},
  { title: '支付方式', dataIndex: 'trade_type_name', key: 'trade_type_name' ,align:"right"},
  { title: '支付状态', dataIndex: 'trade_status', key: '3' ,align:"right"},
  { title: '支付时间', dataIndex: 'dateline', key: '4' ,align:"right"},
]
import tableMixins from '@/common/mixins/table'
export default {
  name: 'xybj',
  props: {
    studentId: Number
  },
  data() {
    return {
      loading: false,
      pageSizeOptions: ['10', '20', '30', '40', '100'],
      current: 1,
      pageParams: {
        currentPage: 1,
        pageCount: 50,
        perPage: 10,
        totalCount: 0
      },
      columns,
      searchParams: {
        "page": 1,
        "per-page": 10,
        "search": {},
        "sort": ''
      },
      list: [],
      current: 1,

      searchData: {},

      visible: false,
      refundVisible: false,
    }
  },

  mixins:[tableMixins],

  methods: {
    async getList() {
      this.loading = true
      this.searchParams.student_id = this.studentId
      let res = await this.$store.dispatch('studentsProfileCostsAction', { data: this.searchParams })
      this.list = res.items

      this.list.push({
        id:-1,
        title:'',
        type:'',
        total_fee:res._total.total_fee,
        out_trade_no:'',
        dateline:'',
      })
      
      this.pageParams = res._meta
      this.loading = false
    },
  }
}
</script>
